import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import {TextPlaceholder} from '../common/placeholders'
import {useVisiblePagination} from '../common/use-visible-pagination'
import {CardBaseWithSash} from './card/card-base-with-sash'
import {ColumnFrame} from './column/column-frame'
import {COLUMN_STYLE} from './constants'

export const PLACEHOLDER_CARD_COUNT = 5

export const BoardPagination: React.FC<{groupId?: string}> = ({groupId}) => {
  const {ref, hasNextPage} = useVisiblePagination({groupId})
  const placeholder = groupId ? <PlaceholderCard /> : <PlaceholderColumn />
  return (
    <div ref={ref} {...testIdProps(`board-pagination${groupId ? `-${groupId}` : ''}`)}>
      {hasNextPage ? placeholder : null}
    </div>
  )
}

const PlaceholderCardUnmemoized: React.FC = () => {
  return (
    <CardBaseWithSash
      {...testIdProps('placeholder-card')}
      className="board-view-column-card"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        p: 2,
        backgroundColor: 'canvas.overlay',
        borderColor: 'border.default',
        borderStyle: 'solid',
        borderRadius: 2,
        borderWidth: '1px',
      }}
    >
      {[...Array(PLACEHOLDER_CARD_COUNT).keys()].map(key => (
        <TextPlaceholder style={{height: 8}} key={key} minWidth={80} maxWidth={200} {...testIdProps('placeholder')} />
      ))}
    </CardBaseWithSash>
  )
}

const PlaceholderColumnUnmemoized: React.FC = () => {
  return (
    <ColumnFrame
      sx={{
        ...COLUMN_STYLE,
        p: 2,
        gap: 2,
      }}
      className="visible"
      headerContent={
        <TextPlaceholder
          style={{height: 12}}
          minWidth={80}
          maxWidth={200}
          {...testIdProps('placeholder-column-header')}
        />
      }
    >
      <PlaceholderCard />
    </ColumnFrame>
  )
}

const PlaceholderCard = memo(PlaceholderCardUnmemoized)
const PlaceholderColumn = memo(PlaceholderColumnUnmemoized)

try{ BoardPagination.displayName ||= 'BoardPagination' } catch {}
try{ PlaceholderCardUnmemoized.displayName ||= 'PlaceholderCardUnmemoized' } catch {}
try{ PlaceholderColumnUnmemoized.displayName ||= 'PlaceholderColumnUnmemoized' } catch {}
try{ PlaceholderCard.displayName ||= 'PlaceholderCard' } catch {}
try{ PlaceholderColumn.displayName ||= 'PlaceholderColumn' } catch {}